(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class NalyaCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.busy = false;
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));
      const checkoutForm = this.querySelector('[data-checkout-form]');
      if (checkoutForm) {
        checkoutForm.addEventListener('submit', () => {
          this.busy = true;
          this.setAttribute('aria-busy', 'true');
        });
      }
      this.syncSelectionControls();
    }

    async handleClick(event) {
      const quantityButton = event.target.closest('[data-quantity-action]');
      if (quantityButton) {
        const line = quantityButton.closest('[data-cart-line]');
        const input = line.querySelector('[data-cart-quantity]');
        const adjustment = quantityButton.dataset.quantityAction === 'increase' ? 1 : -1;
        const quantity = Math.max(0, Number(input.value) + adjustment);
        await this.changeLine(line.dataset.line, quantity);
        return;
      }

      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        await this.changeLine(removeButton.closest('[data-cart-line]').dataset.line, 0);
        return;
      }

      if (event.target.closest('[data-cart-delete-selected]')) {
        await this.deleteSelected();
        return;
      }

      if (event.target.closest('[data-cart-apply-discount]')) {
        await this.applyDiscount();
      }
    }

    async handleChange(event) {
      if (event.target.matches('[data-cart-quantity]')) {
        const line = event.target.closest('[data-cart-line]');
        const quantity = Math.max(0, Number(event.target.value) || 0);
        await this.changeLine(line.dataset.line, quantity);
        return;
      }

      if (event.target.matches('[data-cart-select-all]')) {
        this.querySelectorAll('[data-cart-select-line]').forEach((checkbox) => {
          checkbox.checked = event.target.checked;
        });
        this.syncSelectionControls();
        return;
      }

      if (event.target.matches('[data-cart-select-line]')) {
        this.syncSelectionControls();
      }
    }

    async changeLine(line, quantity) {
      if (this.busy) return;
      await this.requestCart(this.dataset.cartChangeUrl + '.js', {
        line: Number(line),
        quantity: Number(quantity),
        sections: [this.dataset.sectionId],
        sections_url: this.dataset.sectionUrl
      });
    }

    async deleteSelected() {
      if (this.busy) return;
      const selected = [...this.querySelectorAll('[data-cart-select-line]:checked')];
      if (!selected.length) return;
      if (selected.length > 1 && !window.confirm(this.dataset.confirmDelete)) return;

      const updates = [...this.querySelectorAll('[data-cart-line]')].map((line) => {
        const isSelected = line.querySelector('[data-cart-select-line]')?.checked;
        return isSelected ? 0 : Number(line.querySelector('[data-cart-quantity]').value);
      });

      await this.requestCart(this.dataset.cartUpdateUrl + '.js', {
        updates,
        sections: [this.dataset.sectionId],
        sections_url: this.dataset.sectionUrl
      });
    }

    async applyDiscount() {
      if (this.busy) return;
      const input = this.querySelector('[data-cart-discount-input]');
      const message = this.querySelector('[data-cart-discount-message]');
      const code = input?.value.trim();

      if (!code) {
        this.showDiscountError(message);
        input?.focus();
        return;
      }

      this.setBusy(true);
      this.clearError();

      try {
        const response = await fetch(this.dataset.cartUpdateUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            discount: code,
            sections: [this.dataset.sectionId],
            sections_url: this.dataset.sectionUrl
          })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || this.dataset.updateError);

        const normalizedCode = code.toLowerCase();
        const codeApplied = Array.isArray(cart.discount_codes)
          ? cart.discount_codes.some((discount) => {
              return discount.applicable && discount.code?.toLowerCase() === normalizedCode;
            })
          : false;
        const applicationApplied = Array.isArray(cart.cart_level_discount_applications)
          ? cart.cart_level_discount_applications.some((discount) => {
              return discount.title?.toLowerCase() === normalizedCode;
            })
          : false;

        if (!codeApplied && !applicationApplied) {
          this.setBusy(false);
          this.showDiscountError(message);
          return;
        }

        this.renderCart(cart);
      } catch (error) {
        this.setBusy(false);
        this.showError(error.message);
      }
    }

    async requestCart(url, body) {
      this.setBusy(true);
      this.clearError();

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || this.dataset.updateError);
        this.renderCart(cart);
      } catch (error) {
        this.setBusy(false);
        this.showError(error.message);
      }
    }

    renderCart(cart) {
      this.updateHeaderCount(cart.item_count);
      const html = cart.sections?.[this.dataset.sectionId];

      if (!html) {
        window.location.reload();
        return;
      }

      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const incoming = documentFragment.querySelector('[data-cart-root]');
      if (!incoming) {
        window.location.reload();
        return;
      }

      this.replaceWith(incoming);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    }

    updateHeaderCount(count) {
      document.querySelectorAll('.celeste-header__cart').forEach((link) => {
        const badge = link.querySelector('.celeste-header__cart-count');
        if (badge) badge.textContent = String(count);
        const template = this.dataset.cartAriaTemplate;
        if (template) link.setAttribute('aria-label', template.replace('__COUNT__', String(count)));
      });
    }

    syncSelectionControls() {
      const selectAll = this.querySelector('[data-cart-select-all]');
      const checkboxes = [...this.querySelectorAll('[data-cart-select-line]')];
      const selected = checkboxes.filter((checkbox) => checkbox.checked);
      const deleteButton = this.querySelector('[data-cart-delete-selected]');

      if (selectAll) {
        selectAll.checked = checkboxes.length > 0 && selected.length === checkboxes.length;
        selectAll.indeterminate = selected.length > 0 && selected.length < checkboxes.length;
      }
      if (deleteButton) deleteButton.disabled = selected.length === 0;
    }

    showDiscountError(element) {
      if (!element) return;
      element.textContent = this.dataset.discountError;
      element.hidden = false;
    }

    showError(message) {
      const error = this.querySelector('[data-cart-error]');
      const status = this.querySelector('[data-cart-status]');
      this.querySelectorAll('[data-cart-quantity]').forEach((input) => {
        input.value = input.defaultValue;
      });
      if (error) {
        error.textContent = message || this.dataset.updateError;
        error.hidden = false;
      }
      if (status) status.textContent = message || this.dataset.updateError;
    }

    clearError() {
      const error = this.querySelector('[data-cart-error]');
      if (error) {
        error.textContent = '';
        error.hidden = true;
      }
    }

    setBusy(isBusy) {
      this.busy = isBusy;
      this.setAttribute('aria-busy', String(isBusy));
      this.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isBusy;
      });
      if (!isBusy) this.syncSelectionControls();
    }
  }

  if (!customElements.get('nalya-cart')) {
    customElements.define('nalya-cart', NalyaCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class NalyaCatalogue extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.status = this.querySelector('[data-catalogue-status]');
      this.drawer = this.querySelector('[data-filter-drawer]');
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));

      if (this.drawer) {
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.closeDrawer();
        });
      }
    }

    handleClick(event) {
      const openButton = event.target.closest('[data-filter-open]');
      if (openButton) {
        this.openDrawer(openButton);
        return;
      }

      if (event.target.closest('[data-filter-close]')) {
        this.closeDrawer();
        return;
      }

      const loadMoreButton = event.target.closest('[data-load-more]');
      if (loadMoreButton) this.loadMore(loadMoreButton);
    }

    handleChange(event) {
      if (event.target.matches('[data-sort-select]')) event.target.form?.requestSubmit();
    }

    handleSubmit(event) {
      const quickAddForm = event.target.closest('[data-quick-add-form]');
      if (!quickAddForm) return;

      event.preventDefault();
      this.quickAdd(quickAddForm);
    }

    openDrawer(trigger) {
      if (!this.drawer) return;
      this.drawer.showModal();
      this.drawer.dataset.triggerId = trigger.id || '';
      this.drawer.querySelector('[data-filter-close]')?.focus();
    }

    closeDrawer() {
      if (!this.drawer?.open) return;
      const triggerId = this.drawer.dataset.triggerId;
      this.drawer.close();
      if (triggerId) document.getElementById(triggerId)?.focus();
    }

    async quickAdd(form) {
      const button = form.querySelector('[data-quick-add-button]');
      const label = form.querySelector('[data-quick-add-label]');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = button.dataset.loadingLabel;

      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);

        const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();
        this.updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

        label.textContent = button.dataset.successLabel;
        this.announce(button.dataset.successLabel);
        window.setTimeout(() => {
          label.textContent = button.dataset.defaultLabel;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1600);
      } catch (error) {
        label.textContent = button.dataset.defaultLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        this.announce(error.message);
      }
    }

    updateCartCount(count) {
      document.querySelectorAll('.celeste-header__cart').forEach((link) => {
        const badge = link.querySelector('.celeste-header__cart-count');
        if (badge) badge.textContent = String(count);
        if (this.dataset.cartAriaTemplate) {
          link.setAttribute('aria-label', this.dataset.cartAriaTemplate.replace('__COUNT__', String(count)));
        }
      });
    }

    async loadMore(button) {
      const nextUrl = button.dataset.nextUrl;
      const label = button.querySelector('[data-load-more-label]');
      if (!nextUrl || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = button.dataset.loadingLabel;

      try {
        const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(response.statusText);

        const html = await response.text();
        const page = new DOMParser().parseFromString(html, 'text/html');
        const incomingRoot = page.querySelector(`[data-catalogue-root="${this.dataset.sectionId}"]`);
        const incomingGrid = incomingRoot?.querySelector('[data-catalogue-grid]');
        const currentGrid = this.querySelector('[data-catalogue-grid]');
        if (!incomingGrid || !currentGrid) throw new Error('Unable to load more products.');

        [...incomingGrid.children].forEach((card) => currentGrid.append(document.importNode(card, true)));

        const incomingButton = incomingRoot.querySelector('[data-load-more]');
        if (incomingButton?.dataset.nextUrl) {
          button.dataset.nextUrl = incomingButton.dataset.nextUrl;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = button.dataset.defaultLabel;
        } else {
          button.closest('[data-load-more-wrap]')?.remove();
        }

        this.announce(`${incomingGrid.children.length} more products loaded.`);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = button.dataset.defaultLabel;
        this.announce(error.message);
      }
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      window.requestAnimationFrame(() => {
        this.status.textContent = message;
      });
    }
  }

  if (!customElements.get('nalya-catalogue')) {
    customElements.define('nalya-catalogue', NalyaCatalogue);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  class NalyaContact extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const form = this.querySelector('[data-contact-form]');
      const success = this.querySelector('[data-contact-success]');
      const errors = this.querySelector('[data-contact-errors]');

      if (success) success.focus();
      if (errors) errors.focus();

      form?.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const button = form.querySelector('[data-contact-submit]');
        const label = form.querySelector('[data-contact-submit-label]');
        if (!button || !label) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = button.dataset.loadingLabel;
      });
    }
  }

  if (!customElements.get('nalya-contact')) {
    customElements.define('nalya-contact', NalyaContact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-purchase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePurchaseSection = (root) => {
      if (!root || root.dataset.purchaseInitialized === 'true') return;
      root.dataset.purchaseInitialized = 'true';

      const galleryItems = root.querySelectorAll('[data-media-id]');
      const thumbnailButtons = root.querySelectorAll('[data-media-target]');

      thumbnailButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetId = button.dataset.mediaTarget;

          galleryItems.forEach((item) => {
            const active = item.dataset.mediaId === targetId;
            item.hidden = !active;
            item.classList.toggle('is-active', active);
          });

          thumbnailButtons.forEach((thumbnail) => {
            const active = thumbnail === button;
            thumbnail.classList.toggle('is-active', active);
            thumbnail.setAttribute('aria-pressed', String(active));
          });
        });
      });

      const quantityInput = root.querySelector('[data-quantity-input]');
      const quantityMinus = root.querySelector('[data-quantity-minus]');
      const quantityPlus = root.querySelector('[data-quantity-plus]');

      const updateQuantity = (amount) => {
        if (!quantityInput) return;
        const current = Number.parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = Math.max(1, current + amount);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      quantityMinus?.addEventListener('click', () => updateQuantity(-1));
      quantityPlus?.addEventListener('click', () => updateQuantity(1));

      const variantSelect = root.querySelector('[data-variant-select]');
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-product-compare]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      const stickyButton = root.querySelector('[data-sticky-add]');
      const stickyLabel = root.querySelector('[data-sticky-label]');

      const updateVariant = () => {
        if (!variantSelect) return;
        const option = variantSelect.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        const optionPrice = option?.dataset.price || '';
        const compareRaw = Number(option?.dataset.compareRaw || 0);
        const priceRaw = Number(option?.dataset.priceRaw || 0);

        if (price) price.textContent = optionPrice;
        if (stickyPrice) stickyPrice.textContent = optionPrice;

        if (comparePrice) {
          comparePrice.textContent = option?.dataset.compare || '';
          comparePrice.hidden = compareRaw <= priceRaw;
        }

        if (addButton) addButton.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
        if (addLabel) {
          addLabel.textContent = available ? addButton.dataset.defaultLabel : 'Sold out';
        }
        if (stickyLabel) stickyLabel.textContent = available ? 'Add to Cart' : 'Sold out';
      };

      variantSelect?.addEventListener('change', updateVariant);
      updateVariant();

      const stickyBar = root.querySelector('[data-mobile-sticky]');

      if (stickyBar && addButton) {
        const updateSticky = () => {
          if (window.innerWidth >= 750) {
            stickyBar.classList.remove('is-visible');
            return;
          }

          const sectionRect = root.getBoundingClientRect();
          const buttonRect = addButton.getBoundingClientRect();
          const passedMainButton = buttonRect.bottom < 0;
          const sectionReached = sectionRect.top <= 0;

          stickyBar.classList.toggle('is-visible', sectionReached && passedMainButton);
        };

        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky();
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-featured-purchase]').forEach(initializePurchaseSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('celeste-header')) {
    customElements.define(
      'celeste-header',
      class CelesteHeader extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('[data-mobile-drawer]');
          this.closeButton = this.querySelector('[data-drawer-close]');
          this.dropdownMenus = [...this.querySelectorAll('.celeste-header__dropdown')];
          this.onScroll = this.onScroll.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onDrawerToggle = this.onDrawerToggle.bind(this);
          this.onDrawerClick = this.onDrawerClick.bind(this);

          window.addEventListener('scroll', this.onScroll, { passive: true });
          document.addEventListener('keydown', this.onKeydown);
          document.addEventListener('click', this.onDocumentClick);
          this.drawer?.addEventListener('toggle', this.onDrawerToggle);
          this.drawer?.addEventListener('click', this.onDrawerClick);
          this.closeButton?.addEventListener('click', () => this.closeDrawer());
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('keydown', this.onKeydown);
          document.removeEventListener('click', this.onDocumentClick);
          this.drawer?.removeEventListener('toggle', this.onDrawerToggle);
          this.drawer?.removeEventListener('click', this.onDrawerClick);
          document.documentElement.classList.remove('celeste-drawer-open');
        }

        onScroll() {
          this.classList.toggle('is-scrolled', window.scrollY > 18);
        }

        onDrawerToggle() {
          const isOpen = Boolean(this.drawer?.open);
          document.documentElement.classList.toggle('celeste-drawer-open', isOpen);
          if (isOpen) {
            requestAnimationFrame(() => this.closeButton?.focus());
          }
        }

        closeDrawer() {
          if (!this.drawer?.open) return;
          this.drawer.open = false;
          this.querySelector('.celeste-header__menu-toggle')?.focus();
        }

        onDrawerClick(event) {
          if (event.target === this.drawer) {
            this.closeDrawer();
          }
        }

        onKeydown(event) {
          if (event.key === 'Escape') {
            this.closeDrawer();
            this.dropdownMenus.forEach((dropdown) => {
              dropdown.open = false;
            });
          }

          if (event.key !== 'Tab' || !this.drawer?.open) return;
          const focusable = [
            ...this.drawer.querySelectorAll(
              'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
            ),
          ].filter((element) => element.offsetParent !== null);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        onDocumentClick(event) {
          if (this.drawer?.open && !this.drawer.contains(event.target)) {
            this.closeDrawer();
          }

          this.dropdownMenus.forEach((dropdown) => {
            if (!dropdown.contains(event.target)) {
              dropdown.open = false;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits-showcase"] && !Shopify.designMode) return;
  try {
    
  class CelesteProductBenefits extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.variantSelect = this.querySelector('[data-benefits-variant-select]');
      this.price = this.querySelector('[data-benefits-price]');
      this.comparePrice = this.querySelector('[data-benefits-compare-price]');
      this.addButton = this.querySelector('[data-benefits-add-button]');
      this.addLabel = this.querySelector('[data-benefits-add-label]');

      const variantData = this.querySelector('[data-benefits-variants]');
      this.variants = variantData ? JSON.parse(variantData.textContent) : [];

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', () => this.updateVariant());
      }
    }

    updateVariant() {
      const variantId = this.variantSelect?.value;
      const variant = this.variants.find((candidate) => String(candidate.id) === variantId);
      if (!variant) return;

      if (this.price) this.price.textContent = this.formatMoney(variant.price);

      const onSale = variant.compareAtPrice > variant.price;
      if (this.comparePrice) {
        this.comparePrice.hidden = !onSale;
        this.comparePrice.textContent = onSale ? this.formatMoney(variant.compareAtPrice) : '';
      }

      if (this.addButton) this.addButton.disabled = !variant.available;
      if (this.addLabel) {
        this.addLabel.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currency
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }
  }

  if (!customElements.get('celeste-product-benefits')) {
    customElements.define('celeste-product-benefits', CelesteProductBenefits);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class CelesteProductDetail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.variantInput = this.querySelector('[data-variant-id]');
      this.price = this.querySelector('[data-product-price]');
      this.comparePrice = this.querySelector('[data-compare-price]');
      this.saleBadge = this.querySelector('[data-sale-badge]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.inventory = this.querySelector('[data-inventory]');
      this.inventoryLabel = this.querySelector('[data-inventory-label]');
      this.quantityInput = this.querySelector('[data-quantity-input]');

      const variantData = this.querySelector('[data-product-variants]');
      this.variants = variantData ? JSON.parse(variantData.textContent) : [];

      this.querySelectorAll('[data-media-target]').forEach((button) => {
        button.addEventListener('click', () => this.selectMedia(button.dataset.mediaTarget));
      });

      this.querySelectorAll('[data-option-value]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange(input));
      });

      this.querySelectorAll('[data-quantity-button]').forEach((button) => {
        button.addEventListener('click', () => this.updateQuantity(button.dataset.quantityButton));
      });

      this.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
        this.initializeTabs(tabs);
      });
    }

    initializeTabs(tabs) {
      const tabButtons = Array.from(tabs.querySelectorAll('[data-product-tab]'));
      const tabPanels = Array.from(tabs.querySelectorAll('[data-product-tab-panel]'));
      if (tabButtons.length === 0) return;

      const activateTab = (button, moveFocus = false) => {
        const activePanelId = button.getAttribute('aria-controls');

        tabButtons.forEach((tabButton) => {
          const isActive = tabButton === button;
          tabButton.classList.toggle('is-active', isActive);
          tabButton.setAttribute('aria-selected', String(isActive));
          tabButton.tabIndex = isActive ? 0 : -1;
        });

        tabPanels.forEach((panel) => {
          panel.hidden = panel.id !== activePanelId;
        });

        if (moveFocus) button.focus();
      };

      tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => activateTab(button));
        button.addEventListener('keydown', (event) => {
          let targetIndex = null;

          if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabButtons.length;
          if (event.key === 'ArrowLeft') {
            targetIndex = (index - 1 + tabButtons.length) % tabButtons.length;
          }
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = tabButtons.length - 1;

          if (targetIndex == null) return;
          event.preventDefault();
          activateTab(tabButtons[targetIndex], true);
        });
      });
    }

    onOptionChange(input) {
      const fieldset = input.closest('[data-option-position]');
      const selectedLabel = fieldset?.querySelector('[data-selected-option]');
      if (selectedLabel) selectedLabel.textContent = input.value;

      const selectedOptions = Array.from(this.querySelectorAll('[data-option-position]')).map((option) => {
        return option.querySelector('[data-option-value]:checked')?.value;
      });

      const variant = this.variants.find((candidate) => {
        return candidate.options.every((option, index) => option === selectedOptions[index]);
      });

      this.updateVariant(variant);
    }

    updateVariant(variant) {
      if (!variant) {
        if (this.variantInput) this.variantInput.value = '';
        if (this.addButton) this.addButton.disabled = true;
        if (this.addLabel) this.addLabel.textContent = this.dataset.unavailableLabel;
        this.updateInventory(null);
        return;
      }

      if (this.variantInput) {
        this.variantInput.value = variant.id;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.price) this.price.textContent = this.formatMoney(variant.price);

      const onSale = variant.compareAtPrice > variant.price;
      if (this.comparePrice) {
        this.comparePrice.hidden = !onSale;
        this.comparePrice.textContent = onSale ? this.formatMoney(variant.compareAtPrice) : '';
      }
      if (this.saleBadge) this.saleBadge.hidden = !onSale;

      if (this.addButton) this.addButton.disabled = !variant.available;
      if (this.addLabel) {
        this.addLabel.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      this.updateInventory(variant);

      if (variant.featuredMediaId) this.selectMedia(String(variant.featuredMediaId));

      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    updateInventory(variant) {
      if (!this.inventory || !this.inventoryLabel) return;

      this.inventory.classList.toggle('is-unavailable', !variant?.available);

      if (!variant) {
        this.inventoryLabel.textContent = this.dataset.unavailableLabel;
        return;
      }

      if (!variant.available) {
        this.inventoryLabel.textContent = this.dataset.outOfStockLabel;
        return;
      }

      const threshold = Number(this.dataset.inventoryThreshold);
      if (
        variant.inventoryManagement &&
        variant.inventoryQuantity > 0 &&
        variant.inventoryQuantity <= threshold
      ) {
        this.inventoryLabel.textContent = this.dataset.lowStockLabel.replace(
          '__COUNT__',
          variant.inventoryQuantity
        );
        return;
      }

      this.inventoryLabel.textContent = this.dataset.inStockLabel;
    }

    selectMedia(mediaId) {
      const target = this.querySelector(`[data-product-media="${CSS.escape(mediaId)}"]`);
      if (!target) return;

      this.querySelectorAll('[data-product-media]').forEach((media) => {
        const isActive = media === target;
        media.hidden = !isActive;
        media.classList.toggle('is-active', isActive);

        if (!isActive) {
          media.querySelectorAll('video').forEach((video) => video.pause());
        }
      });

      this.querySelectorAll('[data-media-target]').forEach((button) => {
        const isActive = button.dataset.mediaTarget === mediaId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', String(isActive));
      });
    }

    updateQuantity(direction) {
      if (!this.quantityInput) return;
      const current = Math.max(1, Number.parseInt(this.quantityInput.value, 10) || 1);
      this.quantityInput.value = direction === 'increase' ? current + 1 : Math.max(1, current - 1);
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currency
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }
  }

  if (!customElements.get('celeste-product-detail')) {
    customElements.define('celeste-product-detail', CelesteProductDetail);
  }

  } catch(e) { console.error(e); }
})();
})();
